import changeColorPointByStep from './change-color-point-by-step';

const reduceColorPointByStep = (params) => {
  const fallback = {
    rule: 'reduceColorPointByStep',
    params,
  };

  const paramsWithFallback = params.fallback ? params : { ...params, fallback };
  return changeColorPointByStep(paramsWithFallback, true);
};

export default reduceColorPointByStep;
